import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, first } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ChatMessagePayload } from '../models/offer-chat.type';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private readonly http = inject(HttpClient);

  sendMessage(payload: ChatMessagePayload): Observable<Record<string, unknown>> {
    return this.http
      .post<Record<string, unknown>>(`${environment.API_BACK}/chat/enviar`, payload)
      .pipe(first());
  }

  getMessages(id: string | number, offerType: 'spot' | 'contrato'): Observable<Record<string, unknown>[]> {
    let params = new HttpParams();

    if (offerType === 'contrato') {
      params = params.append('coleta', String(id));
    } else {
      params = params.append('lance', String(id));
    }

    return this.http
      .get<Record<string, unknown>[]>(`${environment.API_BACK}/chat/mensagens`, { params })
      .pipe(first());
  }

  getNotifications(): Observable<Record<string, unknown>[]> {
    const headers = new HttpHeaders({ 'X-Skip-Error-Snackbar': '1' });

    return this.http
      .get<Record<string, unknown>[]>(`${environment.API_BACK}/chat/notificacoes`, { headers })
      .pipe(first());
  }
}
